import DetailsButton from './DetailsButton.component';

export default DetailsButton;
